import global from "../config/global";

export default class AFS {
  static measurementStatus = false;

  static startInitialSend() {
    this.measurementStatus = true
  }

  static terminateInitialSend() {
    this.measurementStatus = false
  }

  static reg_suc() {
    this.sendEvents('sign_up')
  }

  static purchase_suc(value, params) {
    AF('pba', 'event', {
        eventType: 'EVENT',
        eventName: 'purchase',
        eventValue: params,
        eventRevenue: value,
      }
    );
  }

  static user_action() {
    this.sendEvents('Lead')
  }

  static sendEvents(name, value = {}) {
    AF('pba', 'event', {
        eventType: 'EVENT',
        eventName: name,
        eventValue: value,
      }
    );
  }
}





// WEBPACK FOOTER //
// ./src/utils/afutils.js